export enum TableColumnType {
  Default,
  Text,
  Action,
  Icon,
  Radio,
  CheckBox,
  InputNumber,
}
